import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const state = {
    indicatordata: {},
    indicatorId: ''
}
const mutations = {
    getindicatordata(state, paylaod){
        state.indicatordata = paylaod
    },
    indicatorId(state, paylaod){
        state.indicatorId = paylaod
    },
}
const getters = {}
const actions = {}

const store = new Vuex.Store({
    state,
    mutations,
    getters,
    actions
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js